import { render, staticRenderFns } from "./intelligentAgentManage.vue?vue&type=template&id=35fd584d&scoped=true"
import script from "./intelligentAgentManage.vue?vue&type=script&lang=js"
export * from "./intelligentAgentManage.vue?vue&type=script&lang=js"
import style0 from "./intelligentAgentManage.vue?vue&type=style&index=0&id=35fd584d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd584d",
  null
  
)

export default component.exports